import s from "./index6.js";
import { openBlock as r, createElementBlock as t, Fragment as l, renderList as o, createBlock as c, resolveDynamicComponent as u } from "vue";
import p from "../../../../_virtual/index.js";
const a = ["href"];
function i(n, f, m, d, _, k) {
  return r(), t("div", null, [
    (r(!0), t(l, null, o(n.cssResources, (e) => (r(), t("link", {
      rel: "stylesheet",
      type: "text/css",
      href: e.url,
      key: e.url
    }, null, 8, a))), 128)),
    (r(!0), t(l, null, o(n.jsResources, (e) => (r(), c(u("script"), {
      type: "application/javascript",
      src: e.url,
      key: e.url,
      defer: !0
    }, null, 8, ["src"]))), 128))
  ]);
}
const v = /* @__PURE__ */ p(s, [["render", i]]);
export {
  v as default
};
//# sourceMappingURL=index5.js.map
